(function($) {

	// Share icons
	$("#share").jsSocials({
		showLabel: false,
    	showCount: false,
    	shareIn: "popup",
		shares: ["facebook", "twitter", "googleplus"]
	});

	// Fullscreen carousel
	var $item = $('#home-carousel .item');
	var $wHeight = $(window).height();
	$item.eq(0).addClass('active');
	$item.height($wHeight);
	$item.addClass('full-screen');

	$('#home-carousel img').each(function() {
		var $src = $(this).attr('src');
		$(this).parent().css({
			'background-image' : 'url(' + $src + ')'
		});
		$(this).remove();
	});

	$(window).on('resize', function (){
		$wHeight = $(window).height();
		$item.height($wHeight);
	});

	$('#home-carousel').carousel({
		interval: false
	});

	$('#home-carousel').on('slide.bs.carousel', function(){
		if($('#home-carousel .item.active audio').length){
			$('#home-carousel .item.active audio')[0].pause();
		}
		$('.btn-play-sound').filter(function(){
			return ($(this).hasClass('stop'));
		}).toggleClass('stop play');


	});

	$('#home-carousel').on('slid.bs.carousel', function(){
		var copyright = $('.item.active').data('credito');
			position = $('.item.active').data('posicao');
		$('#slide-copyright').text(copyright).removeClass().addClass(position);
	});

	// Responsive videos
	$(document).ready(function(){
		$(".responsive-video").fitVids();
	});

	// Play audio
	$('.btn-play-sound').on('click', function(){
		if($('#home-carousel .item.active audio').length){
			var audio = $('#home-carousel .item.active audio')[0];
			$(this).toggleClass('play stop');

			if($(this).hasClass('play')){
				audio.pause();
			}else{
				audio.play();
			}

    		return false;
		}
	});

	// Autotype text
    var frases = {
    	home: "34 pessoas levaram 88 dias para produzir este especial",
    	equipe: "​8.800 unidades de biscoito/bolacha foram consumidas pela equipe",
    	checkup: "9.798.638 doses de remédios são consumidas no Brasil enquanto você lê estas reportagens",
    	corpo: "14.369.202 doses de remédios são consumidas no Brasil enquanto você lê estas reportagens",
    	mente: "8.095.578 doses de remédios são consumidas no Brasil enquanto você lê estas reportagens",
    	comportamento: "6.629.832 doses de remédios são consumidas no Brasil enquanto você lê estas reportagens",
    	servico: "8.122.914 doses de remédios são consumidas no Brasil enquanto você lê estas reportagens",
    };
	var page = $('body').attr('id');

    $("#typed-text").typed({
		strings: [frases[page]],
		typeSpeed: 0,
		startDelay: 500,
		backDelay: 2000,
		loop: true
    });

    // Carousel height
    $.fn.carouselHeights = function() {

	    var items = $(this), //grab all slides
	        heights = [], //create empty array to store height values
	        tallest; //create variable to make note of the tallest slide

	    var normalizeHeights = function() {

	        items.each(function() { //add heights to array
	            heights.push($(this).height());
	        });
	        tallest = Math.max.apply(null, heights); //cache largest value
	        items.each(function() {
	            $(this).css('min-height',tallest + 'px');
	        });
	    };

	    normalizeHeights();

	    $(window).on('resize orientationchange', function () {
	        //reset vars
	        tallest = 0;
	        heights.length = 0;

	        items.each(function() {
	            $(this).css('min-height','0'); //reset min-height
	        });
	        normalizeHeights(); //run it again
	    });

	};

	$(window).on('load', function(){
        $('#article-carousel .item').carouselHeights();
    });

    $('#article-carousel').carousel();

    $('.hotspot').on('click', function(){
    	var caption = $(this).data('caption');
    	$(this).parent().next().text(caption);
    });

    $('.tarja').on('click', function(){
    	var title = $(this).data('title');
    		caption = $(this).data('caption');
    	$('.tarja-title').text(title);
    	$('.tarja-text').html(caption);
    });

})(jQuery);
